import { useEffect, useState } from "react"

export default function ClientOnly({ children }: { children: React.ReactNode }) {
    const [mounted, setMounted] = useState(false)
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setMounted(true)
        }
    }, [])
    if (!mounted) return null
    return children
}
